// @flow
import { rem } from 'polished';
import styled from 'styled-components';

import COLORS from 'client/constants/colors';
import ContentfulTranslate from 'client/components/ContentfulTranslate';

export const SectionHeader = styled.div`
  font-size: ${rem(14)};
  font-weight: 600;
`;

export const SectionContent = styled.div`
  color: ${COLORS.GRAY_3};
  font-size: ${rem(12)};
`;

export const PriceContainer = styled.div`
  font-size: ${rem(14)};
  color: ${({ isTotal = false }) => (isTotal ? COLORS.BLACK : COLORS.GRAY_2)};
  ${({ isTotal = false }) => isTotal && 'font-weight: 700'}
`;

export const RichTextPreWrapTranslate = styled(ContentfulTranslate)`
  p {
    white-space: pre-wrap;
  }
`;

export const DeadlineTranslate = styled(RichTextPreWrapTranslate)`
  p {
    font-size: 1rem;
    font-weight: 600;
  }
`;

export const StyledDeadlineTranslate = styled(DeadlineTranslate)`
  color: ${COLORS.RED_2};
  padding: 0.25rem 0;
`;
